export enum XmlStoreFtpOption {
    None = 'XML_STORE_FTP_NEVER',
    Shop = 'XML_STORE_FTP_SHOP',
    Manual = 'XML_STORE_FTP_MANUAL',
    Both = 'XML_STORE_FTP_BOTH',
}
